var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.icon,style:({
    backgroundImage: `linear-gradient(${_vm.lineGradientColor}, ${_vm.color})`,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }